import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-find-draft',
    templateUrl: './find-draft.component.html',
    styleUrls: ['./find-draft.component.css']
})
export class FindDraftComponent implements OnInit {
    public displaySearchResults = false;
    public searchText = '';

    constructor() { }

    public ngOnInit(): void {
    }

    public onSearch(): void {
        this.displaySearchResults = true;
    }

}
